import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { requestDeviceScreenShot, requestDeviceScreenShotBurst, fetchDeviceScreenShots, setPageTitle } from '../../actions';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Icon from '../../components/widgets/Icon';
import Button from '../../components/widgets/Button';
import { getDeviceWithScreenShots } from '../../selectors/devices';
import './styles.scss';

class DeviceScreenShotsPage extends Component {
  static propTypes = {
    requestDeviceScreenShot: PropTypes.func.isRequired,
    requestDeviceScreenShotBurst: PropTypes.func.isRequired,
    fetchDeviceScreenShots: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    device: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      screenShots: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number.isRequired,
        image: PropTypes.string.isRequired,
        thumbnail: PropTypes.string.isRequired,
        timestamp: PropTypes.string.isRequired,
      })),
    }),
  };

  handleScreenShot = () =>
    this.props.requestDeviceScreenShot(this.props.device)

  handleScreenShotBurst = () =>
    this.props.requestDeviceScreenShotBurst(this.props.device)

  componentDidMount() {
    if (this.props.device) {
      this.props.setPageTitle(`${this.props.device.name} Screenshots`);
    }
  // Set interval to fetch device screenshots every one minute
  this.fetchInterval = setInterval(() => {
    this.props.fetchDeviceScreenShots();
  }, 60000); // 60000 milliseconds = 1 minute
  }
  // Don't forget to clear the interval when the component unmounts
  componentWillUnmount() {
    clearInterval(this.fetchInterval);
  } 

  render() {
    const { device } = this.props;
    return (
      <Page className="device-screen-shots-page">
        <Box direction="row" justifyContent="flex-end" className="button-group">
        <Icon
            title="Refresh for Screenshots"
            name="refresh"
            size="2rem"
            className={`is-cursor`}
            onClick={(e) => {
              this.props.fetchDeviceScreenShots();
              e.currentTarget.style.transition = 'transform 3s linear';
              e.currentTarget.style.transform = 'rotate(360deg)';
              setTimeout(() => {
                e.currentTarget.style.transition = '';
                e.currentTarget.style.transform = '';
              }, 3000)
            }}
            />
          <Button primary onClick={this.handleScreenShot}>Take ScreenShot</Button>
          <Button secondary onClick={this.handleScreenShotBurst}>Take ScreenShot Burst</Button>
          
        </Box>
        {device && device.screenShots.length > 0 ? 
        <Box direction="row" wrap justifyContent="space-between" className="screen-shots-list">
          {device.screenShots.map(screenShot => (
            <Box direction="column" key={screenShot.id} className="screen-shots-list__item depth-1">
              <a href={screenShot.image} target="_blank" rel="noopener noreferrer">
                <img src={screenShot.thumbnail}
                     alt={`ScreenShot of ${this.props.device.name} taken on ${screenShot.timestamp}`}/>
              </a>
              <span className="timestamp">
                {new Date(screenShot.timestamp).toString()}
              </span>
            </Box>
          ))}
        </Box>:
        <p className='text-center mt-1'>No screenshots available for {device ? device.name : 'this device'}.</p>}

      </Page>
    );
  }
}

export default connect((state, {match}) => ({
  device: getDeviceWithScreenShots(state, parseInt(match.params.id, 10)),
}), {
  requestDeviceScreenShot,
  requestDeviceScreenShotBurst,
  setPageTitle,
  fetchDeviceScreenShots,
})(DeviceScreenShotsPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DeviceScreenShotsPage/index.js